import React from 'react';
import { st, classes } from './FunnelBar.st.css.js';
export const FunnelBar = ({ height, dataHook }) => {
    return (React.createElement("div", { className: st(classes.root), "data-hook": dataHook },
        React.createElement("div", { style: { height: `${height}%` }, className: classes.filledBar })));
};
//# sourceMappingURL=FunnelBar.js.map